import { BiEditAlt, BiTrashAlt, BiCalendar } from 'react-icons/bi'
import { useClube } from '../../contextClube'
import moment from 'moment'

import { Container, Title, Info, Slider } from './style'



export function CardProperties({obj, border}) {
    const { 
        setModalFormsMainIsOpen, 
        handleDeleteMainProperty, 
        setMainPageToEdit,
        handleSwitchButtonMainPage 
    } = useClube()
    const initialDate = moment(obj.initDate.slice(0, 16)).format('DD/MM/YYYY')
    const finalDate = obj.lastDate === null || obj.lastDate === ''  ? '-' : moment(obj.lastDate.slice(0, 16)).format('DD/MM/YYYY')


    function handleEditMainProperty() {
        setModalFormsMainIsOpen(true)
        setMainPageToEdit(obj)
    }


    return(
        <Container border={border}>
            <div className="management">
                <BiTrashAlt onClick={() => handleDeleteMainProperty(obj.id)} />
                <BiEditAlt onClick={handleEditMainProperty} />
                <Slider 
                    onClick={() => handleSwitchButtonMainPage(obj.id)}
                    switchButtonActive={obj.active} 
                >
                    <div className="circle"/>
                </Slider>
            </div>

            <Title>
                <p>{obj.title}</p>
            </Title>
            <Info>
                <div>
                    <BiCalendar />
                    <time>{initialDate}</time>
                </div>
                
                <div>
                    <BiCalendar />
                    <time>{finalDate}</time>
                </div>
            </Info>
        </Container>
    )
}
